import { colors, fontSizes } from 'app/theme'
import css from 'styled-jsx/css'

export default css`
  .pdf-viewer-container {
    display: flex;
    flex-direction: column;
    height: 65vh;
    width: 100%;
    max-width: 95vw;
    margin: 0 auto;
    background: ${colors.white};
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    overflow: hidden;
  }

  .pdf-viewer-container.fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1101;

    height: 100%;
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    min-width: 100%;
    min-height: 100%;
    border-radius: 0;
  }

  .pdf-viewer-container:-webkit-full-screen {
    height: 100vh;
    width: 100vw;
    max-width: 100vw;
    border-radius: 0;
  }

  .pdf-viewer-container:-moz-full-screen {
    height: 100vh;
    width: 100vw;
    max-width: 100vw;
    border-radius: 0;
  }

  .pdf-viewer-container:-ms-fullscreen {
    height: 100vh;
    width: 100vw;
    max-width: 100vw;
    border-radius: 0;
  }

  .pdf-viewer-controls {
    display: flex;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid #e1e5e9;
    background-color: #f8f9fa;
  }

  .pdf-viewer-actions {
    display: flex;
    gap: 8px;
    justify-content: flex-start;
    align-items: center;
  }
  .pdf-viewer-zoom {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  .pdf-viewer-zoom  .pdf-viewer-percentage {
    font-size: ${fontSizes.small};
  }

  .pdf-viewer-actions .pdf-viewer-action-button-text {
    margin-left: 0.5rem;
  }

  .pdf-viewer-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
  }

  .pdf-viewer-loading {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    gap: 12px;
    color: #6c757d;
  }

  .pdf-viewer-error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    gap: 16px;
    color: #dc3545;
    text-align: center;
    padding: 20px;
  }

  .error-actions {
    display: flex;
    gap: 12px;
    margin-top: 16px;
  }

  .pdf-document-container {
    flex: 1;
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .pdf-iframe {
    width: 100%;
    height: 100%;
    border: none;
    background-color: #fff;
  }

  .pdf-object {
    width: 100%;
    height: 100%;
    border: none;
  }

  .pdf-fallback {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    gap: 16px;
    padding: 20px;
    text-align: center;
    color: #6c757d;
  }

  @media (max-width: 768px) {
    .pdf-viewer-container {
      height: 85vh;
      max-width: 100vw;
    }
    
    .pdf-viewer-actions {
      flex-wrap: wrap;
      gap: 6px;
    }
    
    .error-actions {
      flex-direction: column;
      gap: 8px;
    }

    .pdf-viewer-zoom  .pdf-viewer-percentage {
      display: none;
    }
  }

  @media (max-width: 576px) {
    .pdf-viewer-actions {
      gap: 1rem;
    }
    .pdf-viewer-actions .pdf-viewer-action-button-text {
      display: none;
    }
  }
`
